import { SessionContext } from '@/context/SessionContext';
import { Button, Group, Modal, Stack, Text, TextInput, Textarea, } from '@mantine/core';
import { useContext, useState } from 'react';

interface SongRequestModalProps {
	showModal: boolean;
	setShowModal: (show: boolean) => void;
}

const SongRequestModal: React.FC<SongRequestModalProps> = ({ showModal, setShowModal }) => {
	const session = useContext(SessionContext);
	if (!session) {
		throw new Error('SongRequestModal must be used within a SessionProvider.');
	}

	// form input state
	const [songName, setSongName] = useState('');
	const [artistName, setArtistName] = useState('');
	const [message, setMessage] = useState('');
	const [email, setEmail] = useState('');
	const [submitted, setSubmitted] = useState(false);

	// Check if user's email is available in the session context
	const userEmail = session.user?.email?.trim() || '';
	const isEmailMissing = userEmail === '';

	// Handle form submission
	const handleSubmit = () => {
		const finalEmail = isEmailMissing ? email.trim() : userEmail;
		if (finalEmail === '') {
			alert('Please enter your email to receive updates.');
			return;
		}

		console.log('Song Name:', songName);
		console.log('Artist Name:', artistName);
		console.log('Message:', message);
		console.log('Email:', finalEmail);

		setSubmitted(true);
	};

	// Reset modal and form state when closing
	const handleClose = () => {
		setShowModal(false);
		setSubmitted(false);
		setSongName('');
		setArtistName('');
		setMessage('');
		setEmail('');
	};

	return (
		<Modal
			opened={showModal}
			onClose={handleClose}
			title="Request a Song/Artist"
			centered
			size="lg"
		>
			{submitted ? (
				<Stack align="center" gap="md">
					<Text fw={700} fz="lg">You’ve sent a Request!</Text>
					<Text ta="center">
						An email confirmation has been sent to you, and your profile has been updated.
					</Text>
					<Button variant="outline" onClick={handleClose}>Back to Profile Page</Button>
				</Stack>
			) : (
				<Stack>
					<TextInput
						label="Song Name"
						placeholder="Enter the song title"
						value={songName}
						onChange={(e) => setSongName(e.currentTarget.value)}
					/>

					<TextInput
						label="Artist Name"
						placeholder="Enter the artist name"
						value={artistName}
						onChange={(e) => setArtistName(e.currentTarget.value)}
					/>

					<Textarea
						label="Additional Message"
						placeholder="Write here..."
						value={message}
						onChange={(e) => setMessage(e.currentTarget.value)}
					/>

					{isEmailMissing && (
						<TextInput
							label="Your Email"
							placeholder="abc123@gmail.com"
							type="email"
							value={email}
							onChange={(e) => setEmail(e.currentTarget.value)}
							required
						/>
					)}
					{/* TODO: Add the API Call */}

					<Group justify="center" mt="sm">
						<Button onClick={handleSubmit}>Submit</Button>
					</Group>
				</Stack>
			)}
		</Modal>
	);
};

export default SongRequestModal;
